export enum MenuItems {
  LOST = 'lost-ticket',
  TOGETHER = 'together',
  TOGETHER_SALE = 'ade-actie',
  LOGIN = 'login',
  REGISTER = 'register',
  FOOTER = 'footer',
  DASHBOARD = 'dashboard',
  SHOP = 'shop',
  SETTINGS = 'settings',
  MARKETING = 'marketing',
  STATISTICS = 'statistics',
  FINANCE = 'finance',
}
